import type { ChatTool, ToolUseProps } from "../Chat/ChatTool";
import { ToolStatus } from "../Chat/ToolStatus";

function Header({ toolUse, result, interrupted }: ToolUseProps) {
  const name = (toolUse.input as { name?: string } | undefined)?.name;
  if (!result)
    return (
      <ToolStatus
        icon="product-workflows"
        text={`Handing off to ${name ?? "a new workflow"}…`}
        pending={!interrupted}
      />
    );
  return (
    <ToolStatus
      icon="product-workflows"
      text={
        result.isError
          ? `Couldn’t create ${name ?? "the workflow"}`
          : `Handed off to ${name ?? "the workflow"}`
      }
    />
  );
}

export const createWorkflowHandoff: ChatTool = {
  name: "createWorkflow",
  Header,
};
